module.exports = __webpack_public_path__ + "img/t2.1a109db9.png";